module.exports = __webpack_public_path__ + "static/media/B7.4369b5fb.jpg";